"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationApiService = void 0;
var constants_1 = require("../../constants");
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var PreloadData_service_1 = require("../PreloadData.service");
var lowerCaseFirstChar_1 = require("../../../util/lowerCaseFirstChar");
var Http_service_1 = require("../../../core/services/http/Http.service");
var Language_service_1 = require("../Language.service");
var JsonApi_service_1 = require("./JsonApi.service");
var object_observer_1 = require("object-observer");
var NewRelicPageAction_service_1 = require("../../../core/services/NewRelicPageAction.service");
var ApplicationApiService = /** @class */ (function () {
    function ApplicationApiService(jsonApiService, httpService, preloadDataService, languageService, newRelicPageActionService) {
        this.jsonApiService = jsonApiService;
        this.httpService = httpService;
        this.preloadDataService = preloadDataService;
        this.languageService = languageService;
        this.newRelicPageActionService = newRelicPageActionService;
    }
    ApplicationApiService.prototype.innerGetApplicationInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var preloadData, application, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        preloadData = this.preloadDataService.getPreloadData();
                        application = (preloadData || {}).application;
                        if (application)
                            return [2 /*return*/, { ServiceResult: application }];
                        return [4 /*yield*/, this.jsonApiService.getApiUrl('ApplicationService', 'application')];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.post(url, { test: true }, { cache: 'variable' })];
                }
            });
        });
    };
    ApplicationApiService.prototype.getApplicationInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appInfo, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.innerGetApplicationInfo()];
                    case 1:
                        appInfo = _a.sent();
                        return [4 /*yield*/, this.patchLabelForDeliveryOptions(appInfo.ServiceResult.System.DeliveryOptions)];
                    case 2:
                        _a.sent();
                        if ('function' === typeof window.Proxy) {
                            result = object_observer_1.Observable.from(appInfo);
                            result.observe(function (changes) {
                                changes.forEach(function (change) {
                                    _this.newRelicPageActionService.addPageAction('GlobalApplicationInfoMutation', {
                                        mutationType: change.type,
                                        mutationPath: JSON.stringify(change.path),
                                    });
                                    console.error("Please don't mutate the global `ApplicationInfo`, here is the details:", change);
                                });
                            });
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/, appInfo];
                }
            });
        });
    };
    /**
     * Transforms each delivery option's label to its translated version
     * @param deliveryOptions
     * @param languageCode
     */
    ApplicationApiService.prototype.patchLabelForDeliveryOptions = function (deliveryOptions, languageCode) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var translations;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (typeof ((_a = deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions[0]) === null || _a === void 0 ? void 0 : _a.Label) === 'function') {
                            return [2 /*return*/, deliveryOptions];
                        }
                        return [4 /*yield*/, this.languageService.getTranslations(languageCode || this.languageService.getLanguage(), 'ToolKit', 'Default')];
                    case 1:
                        translations = _b.sent();
                        deliveryOptions.forEach(function (option) {
                            // eslint-disable-next-line no-param-reassign
                            option.Label = function () { return translations[constants_1.DeliveryOptionsTypeToI18NKey[option.Type]] || option.Name; };
                        });
                        return [2 /*return*/, deliveryOptions];
                }
            });
        });
    };
    ApplicationApiService.prototype.getCurrentUser = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var application, appUser, systemLevelPermissions;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getApplicationInfo()];
                    case 1:
                        application = _d.sent();
                        appUser = (_b = (_a = application === null || application === void 0 ? void 0 : application.ServiceResult) === null || _a === void 0 ? void 0 : _a.User) !== null && _b !== void 0 ? _b : {};
                        systemLevelPermissions = (_c = appUser.SystemLevelPermissions) === null || _c === void 0 ? void 0 : _c.map(function (p) { return lowerCaseFirstChar_1.lowerCaseFirstCharKeys(p); });
                        return [2 /*return*/, lowerCaseFirstChar_1.lowerCaseFirstCharKeys(__assign(__assign({}, appUser), { systemLevelPermissions: systemLevelPermissions }))];
                }
            });
        });
    };
    /**
     * @deprecated
     * Please move it into NewsCenter repo
     */
    ApplicationApiService.prototype.getNewsCenterApplicationInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.jsonApiService.getApiUrl('ApplicationService', 'application/newscenter')];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.post(url, {}, { cache: 'variable' })];
                }
            });
        });
    };
    /**
     * @deprecated
     * Please move it into DocCenter repo
     */
    ApplicationApiService.prototype.getDocCenterApplicationInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.jsonApiService.getApiUrl('ApplicationService', 'application/doccenter')];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.post(url, {}, { cache: 'variable' })];
                }
            });
        });
    };
    /**
     * @deprecated
     * Please move it into Workspace repo
     */
    ApplicationApiService.prototype.getWorkspaceApplicationInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.jsonApiService.getApiUrl('ApplicationService', 'application/workspace')];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.post(url, {}, { cache: 'variable' })];
                }
            });
        });
    };
    /**
     * @deprecated
     * Please move it into Predictive repo
     */
    ApplicationApiService.prototype.getPredictiveApplicationInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.jsonApiService.getApiUrl('ApplicationService', 'application/predictive')];
                    case 1:
                        url = _a.sent();
                        return [2 /*return*/, this.httpService.post(url, {}, { cache: 'variable' })];
                }
            });
        });
    };
    ApplicationApiService = __decorate([
        CommonService_decorator_1.CommonService('ApplicationApiService'),
        __metadata("design:paramtypes", [JsonApi_service_1.JsonApiService,
            Http_service_1.HttpService,
            PreloadData_service_1.PreloadDataService,
            Language_service_1.LanguageService,
            NewRelicPageAction_service_1.NewRelicPageActionService])
    ], ApplicationApiService);
    return ApplicationApiService;
}());
exports.ApplicationApiService = ApplicationApiService;
//# sourceMappingURL=ApplicationApi.service.js.map